import { render, staticRenderFns } from "./AcademyEventsTab.vue?vue&type=template&id=47ebb009&scoped=true"
import script from "./AcademyEventsTab.vue?vue&type=script&lang=js"
export * from "./AcademyEventsTab.vue?vue&type=script&lang=js"
import style0 from "./AcademyEventsTab.vue?vue&type=style&index=0&id=47ebb009&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ebb009",
  null
  
)

export default component.exports